module.exports = __webpack_public_path__ + "static/media/Justice-kannan.82692307.png";